import { createContext } from "react";

const QueryTableContext = createContext();

export default QueryTableContext;
